import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { navbardata } from './sidepannel._const';
import { version } from '../../../version';
@Component({
  selector: 'app-sidepannel',
  templateUrl: './sidepannel.component.html',
  styleUrls: ['./sidepannel.component.css']
})
export class SidepannelComponent implements OnInit {
  isShown: boolean = true;
  version = version;
  constructor(private router: Router, private route: ActivatedRoute) { }
  @Input() collapsed: boolean = true;
  sidebardata = navbardata
  userType: any
  ngOnInit(): void {
    console.log(this.sidebardata)
    this.userType = localStorage.getItem('userTypecon')
    this.updateMenuVisibility()
  }

  // updateMenuVisibility() {
  //   this.sidebardata.forEach(item => {
  //     if ((this.userType.toUpperCase() === 'HR_MANAGER' || this.userType.toUpperCase() === "FINANCE_MANAGER") && (item.label == "HR Module" || item.label == "CRM" || item.label == "KPI" || item.label == "Attendance Request" || item.label == "Employee Attendence")) {
  //       item.show = true;
  //     } else if (this.userType.toUpperCase() === "MARKETING" && item.label == "Messaging Broadcast") {
  //       item.show = true
  //     } else if (this.userType.toUpperCase() === 'ADMIN') {
  //       item.show = true
  //     } else if ((this.userType.toUpperCase() == 'SALESMAN' || this.userType.toUpperCase() == 'SALES_PROMOTER' || this.userType.toUpperCase() == 'UAE_WHOLESALE_SALESMAN') && (item.label == 'Dashboard' || item.label == 'Sales' || item.label == 'Sales Projections'  || item.label == 'Meeting')) {
  //       item.show = true
  //       // debugger
  //     } else if ((this.userType.toUpperCase() == 'DEPARTMENT_FOREMAN') && (item.label == 'Dashboard' || item.label == 'Sales' || item.label == 'Sales Projections' || item.label == 'HR Module')) {
  //       item.show = true
  //       // debugger
  //     } else if ((this.userType.toUpperCase() == 'FACTORY_MANAGER') && (item.label == 'Dashboard' || item.label == 'Factory' || item.label == 'User Details' )) {
  //       item.show = true
  //     }
  //   });
  // }
  updateMenuVisibility() {
    const userType = this.userType.toUpperCase() as keyof typeof menuVisibilityConfig;

    // Define which menu items are visible for each user type
    const menuVisibilityConfig = {
      HR_MANAGER: new Set(["HR Module", "CRM", "KPI", "Attendance Request", "Leave Requests", "Employee Attendence", "Complaints","Meeting","Employee Attendance Beta","Customer Survey","KPI Monthly Report","Hr Portal"]),
      FINANCE_MANAGER: new Set(["Meeting","HR Module","CRM", "KPI", "Attendance Request", "Leave Requests", "Employee Attendence", "Complaints","Employee Attendance Beta","Factory Customer Survey","KPI Monthly Report"]),
      MARKETING: new Set(["Messaging Broadcast", "Complaints"]),
      ADMIN: new Set([...this.sidebardata.map(item => item.label)]), // Admin can see all items
      SALESMAN: new Set(["Dashboard", "Sales", "Sales Projections", "Meeting", "Complaints"]),
      SALES_PROMOTER: new Set(["Dashboard", "Sales", "Sales Projections", "Meeting", "Complaints"]),
      UAE_WHOLESALE_SALESMAN: new Set(["Dashboard", "Sales", "Sales Projections", "Meeting", "Complaints"]),
      DEPARTMENT_FOREMAN: new Set(["Dashboard", "Sales", "Sales Projections", "HR Module", "Complaints","Meeting"]),
      CFGS_FOREMAN: new Set(["Dashboard", "Sales", "Sales Projections", "HR Module", "Complaints","Meeting"]),
      FACTORY_MANAGER: new Set(["Dashboard", "Factory", "Complaints", "Employee Attendance Beta","KPI Monthly Report"]),
      FACTORY_ADMIN: new Set(["Dashboard", "Factory", "User Details", "Complaints", "Employee Attendence","Employee Attendance Beta"]),
      PRODUCTION_SUPERVISOR: new Set(["Dashboard", "Factory"]),
      RAW_MATERIAL_INCHARGE: new Set(["Dashboard", "Employee Attendence","Employee Attendance Beta"]),
      PACKING_SUPERVISOR: new Set(["Dashboard", "Employee Attendence","Employee Attendance Beta"]),
      QC_CHEMIST: new Set(["Dashboard", "Employee Attendence","Factory","Employee Attendance Beta"]),
      // ✅ NEW ROLE: MANAGER
      MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      ADMIN_OPERATIONS: new Set(["Meeting"]),
      EXPORT_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      INDIA_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      KSA_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      OMAN_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      OPERATIONS_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      PRODUCTION_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      SALES_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      SERVICE_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      STORE_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      WAREHOUSE_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      DELIVERY_MANAGER: new Set(["Meeting","KPI Monthly Report"]),
      CUSTOMER_SURVEY: new Set(["Web Punching","Customer Survey"]),
      MIXER: new Set(["Mixing job"]),
      OPERATIONS_EXECUTIVE: new Set([...this.sidebardata.map(item => item.label)]),
      


    };

    // Get the allowed menu items for the current user type
    const allowedMenuItems = menuVisibilityConfig[userType] || new Set();


    // Update the visibility of each menu item
    this.sidebardata.forEach(item => {
      item.show = allowedMenuItems.has(item.label);

    });
  }
  ngOnDestroy(): void {
    this.sidebardata.forEach(item => {
      item.show = false;
    });
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed
  }
  dash() {
    this.router.navigateByUrl(('admin'));
    this.isShown = true;

  }

  //for routing to employee management module
  employee() {
    //this.router.navigate(['employee-management'], {relativeTo:this.route});
    this.router.navigateByUrl(('admin/employee-management'));
    this.isShown = false;
  }

  //for routing to user detail module
  user() {
    this.router.navigateByUrl(('admin/user-detail'));
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to product listing module
  products() {
    this.router.navigate(['products'], { relativeTo: this.route });
    //this.router.navigate(['product-details'],{relativeTo:this.route});
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //------routing to product advice page--------------
  productAdvice() {
    this.router.navigate(['product-advice'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }



  //for routing to customer visit list
  customerVisit() {
    this.router.navigate(['customer-visit'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to customer approvals
  customerApprovals() {
    this.router.navigate(['customer-approval'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }
  //routing to sales projection
  Sales_projection() {
    this.router.navigate(['sales-projection'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //routing to roductions
  production() {
    this.router.navigate(['productions'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }
  //for routing to leads
  leads() {
    this.router.navigate(['leads'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to customer visit list
  customer() {
    this.router.navigate(['customer'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to crm
  crm() {
    this.router.navigate(['CRM'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to folder
  folder() {
    this.router.navigate(['folder'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to invoices
  invoices() {
    this.router.navigate(['invoices'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to kyc
  kyc() {
    this.router.navigate(['KYC'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  attendance() {
    this.router.navigate(['Attendance-request'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to receipts
  receipts() {
    this.router.navigate(['receipts'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  reports() {
    this.router.navigate(['reports'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to machines
  machine() {
    this.router.navigate(['machine'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to customer complaints
  customer_complaints() {
    this.router.navigate(['customer-compliant'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to product complaints
  product_complaints() {
    this.router.navigate(['product-complaint'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }
  //for routing to brand details
  brands() {
    this.router.navigate(['brands'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to product stock
  stock() {
    this.router.navigate(['product-stock'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to department
  department() {
    this.router.navigate(['department'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  //for routing to Warehouse
  Warehouse() {
    this.router.navigate(['Warehouse'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to Attendence
  Attendence() {
    this.router.navigate(['employee-attendence'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routng to user privileges
  userPrivileges() {
    this.router.navigate(['user-privileges'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  //for routing to sate orders
  orders() {
    this.router.navigate(['sale-orders'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }

  //for routing to kpi menu
  KPI() {
    this.router.navigate(['kpi-menu'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }

  Marketing() {
    this.router.navigate(['marketing-visit'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  Market() {
    this.router.navigate(['all-market-study'], { relativeTo: this.route });
    this.isShown = false;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

}
